import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import { getPieceworkState } from './pieceworkSlice';
import fetchMarketResearchThunk from './services/fetchMarketResearchThunk';
import updateMarketResearchCitiesThunk from './services/updateMarketResearchCitiesThunk';
import { APIStatus } from '../../services/axiosEnums';

interface IUsePieceworkProps {
  loadMarketResearch?: boolean;
}
function usePiecework({ loadMarketResearch }: IUsePieceworkProps) {
  const { marketResearch } = useAppSelector(getPieceworkState);
  const dispatch = useAppDispatch();

  const loadMarketResearchDatas = () => dispatch(fetchMarketResearchThunk());
  const handleCityChange = (cities: Cities) => {
    const idIris = cities.map((m) => m.idIri);
    dispatch(updateMarketResearchCitiesThunk({ idIrisProps: idIris }));
  };
  useEffect(() => {
    if (loadMarketResearch && !marketResearch.result.cities) {
      loadMarketResearchDatas();
    }
  }, [loadMarketResearch, marketResearch.result.cities]);

  return {
    marketResearchStatusPending: marketResearch.apiStatus === APIStatus.PENDING,
    marketResearchIdIri: marketResearch.result.idIri,
    totalAds: marketResearch.result.totalAds,
    totalNewAds: marketResearch.result.totalNewAds,
    cities: marketResearch.result.cities,
    handleCityChange,
  };
}

export default usePiecework;
